import { drawCategoryTypeIds } from './eventConstants';
import { allStandingsEnabled, shouldDisplayDraws } from './events';
import { getDrawName } from './courtSchedular';

export const resolveDisplayedDraws = ({
    parentDraw,
    currentDraw,
    drawsDict,
    firstPublishedDraw,
}) => {
    const displayedParentDraw = (parentDraw?.pendingId && drawsDict?.[parentDraw.pendingId]) ||
        parentDraw?.data ||
        firstPublishedDraw ||
        null;

    const rawDisplayedCurrentDraw = (currentDraw?.pendingId && drawsDict?.[currentDraw.pendingId]) ||
        currentDraw?.data ||
        null;

    const isGroupedParent = displayedParentDraw?.categoryTypeId === drawCategoryTypeIds.GROUPED;
    const shouldFallbackToFirstChild = isGroupedParent &&
        rawDisplayedCurrentDraw?.id === displayedParentDraw.id;

    const displayedCurrentDraw = shouldFallbackToFirstChild
        ? (drawsDict?.[displayedParentDraw.id]?.childDraws?.[0] || rawDisplayedCurrentDraw)
        : rawDisplayedCurrentDraw;

    return { displayedParentDraw, displayedCurrentDraw, isGroupedParent };
};

export const buildChildDrawMenuItems = ({
    displayedParentDraw,
    drawsDict,
    drawCategoryTypesDict,
    isAllStandingsFlagEnabled,
    userDrawIds,
}) => {
    if (!displayedParentDraw || !drawsDict?.[displayedParentDraw.id]) {
        return [];
    }

    const isGroupedParent = displayedParentDraw.categoryTypeId === drawCategoryTypeIds.GROUPED;

    const childDraws = drawsDict[displayedParentDraw.id].childDraws
        .filter(shouldDisplayDraws)
        .map(cd => ({
            value: cd.id,
            label: getDrawName(cd, displayedParentDraw, drawCategoryTypesDict),
            playing: userDrawIds?.includes(cd.id),
        }));

    const isAllStandingsEnabled = displayedParentDraw.eliminationTypeId &&
        allStandingsEnabled(displayedParentDraw) &&
        isAllStandingsFlagEnabled;

    return [
        ...(isAllStandingsEnabled ? [{
            value: '',
            label: 'All standings',
        }] : []),
        ...(isGroupedParent ? [] : [{
            value: displayedParentDraw.id,
            label: getDrawName(displayedParentDraw, displayedParentDraw, drawCategoryTypesDict),
        }]),
        ...childDraws,
    ];
};
